"use strict";

exports.__esModule = true;
exports.TilesWrapped = void 0;

var _styled = require("../../../styles/styled");

var TilesWrapped = _styled.styled.div.withConfig({
  componentId: "sc-17efvvx-0"
})(["display:flex;align-content:flex-start;flex-wrap:wrap;"]);

exports.TilesWrapped = TilesWrapped;